import { Flex } from '@applatform/design-system';
import { ReactComponent as ZaiPaymentsLogo } from 'icons/zai-payments-logo.svg';

function Brand() {
  return (
    <Flex
      css={{
        alignItems: 'center',
        pt: '$4',
        px: '$4',
        pb: '$3',
        '& > svg': {
          display: 'block',
          width: '100%',
          minWidth: '70px',
          maxWidth: '132px',
          height: 'auto',
        },
      }}
    >
      <ZaiPaymentsLogo role="img" aria-label="Zai Payments" />
    </Flex>
  );
}

export default Brand;
